import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {useIncrementingId} from '#hooks/useIncrementingId'

function Upload({accept = '*', labelText, modifier, onChangeHandle, isUploading, disabled}) {
  const id = useIncrementingId()

  const modifierClass = modifier ? ` upload--${modifier}` : ''
  return (
    <div testid="profile_photo_button" className={`upload${modifierClass}`}>
      <label htmlFor={id}>
        <span>{isUploading ? i18n.t('upload_progress_hint') : labelText}</span>
        <input
          id={id}
          data-testid="upload-input"
          type="file"
          onChange={onChangeHandle ? elem => onChangeHandle(elem) : undefined}
          accept={accept}
          disabled={isUploading || disabled}
        />
      </label>
    </div>
  )
}

Upload.propTypes = {
  accept: PropTypes.string,
  labelText: PropTypes.string,
  modifier: PropTypes.string,
  onChangeHandle: PropTypes.func,
  isUploading: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default Upload
